import { CATALOG_ROUTES } from 'domains/Catalog/catalogRoutes';

export const AGENT_ENABLED_ROUTES: string[] = [
  CATALOG_ROUTES.newProduct,
  CATALOG_ROUTES.editProduct,
];
